module.exports = __webpack_public_path__ + "media/images/categories/carousel/science-09418442e3e66e572a3004171da59b9c.jpg";